export function createLocale(locale, moduleName = 'employees') {
  return { [moduleName]: locale };
}
